import React, { Component } from 'react';
import { Form, Input, Select, DatePicker } from 'antd';
import { FormLayout } from '@/components';
import moment from 'moment';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { CHECK_name, CHECK_phone } from '@/shared/reqexp';
const mapStateToProps = (rootState) => ({
    _state: rootState.seller,
});
class FormSearchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.search = this.search.bind(this);
    }
    search(data) {
        dispatch.seller.SET_STATE({
            searchData: data,
        });
        dispatch.seller.updateTable({ page: 1 });
    }
    dealDate(currentDate) {
        const now = moment();
        return currentDate > now;
    }
    componentWillMount() {
        dispatch.seller.getGroupName({});
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { allGroupName } = this.props._state;
        return (<FormLayout form={this.props.form} onSearch={this.search}>
        <Form.Item label={'经销商名称'}>
          {getFieldDecorator('name', {
            rules: [{
                    validator: CHECK_name(50),
                }],
        })(<Input placeholder={'请输入经销商名称'}/>)}
        </Form.Item>
        <Form.Item label={'手机号'}>
          {getFieldDecorator('moblie', {
            rules: [{
                    pattern: CHECK_phone,
                    message: '请输入正确格式的手机号',
                }],
        })(<Input placeholder={'请输入手机号'}/>)}
        </Form.Item>
        <Form.Item label={'所属集团'}>
          {getFieldDecorator('groupName')(<Select placeholder="请选择所属集团" getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {allGroupName.map((item) => (<Select.Option key={item}>{item}
                  </Select.Option>))}
            </Select>)}
        </Form.Item>
        <Form.Item label={'所属区域'}>
          {getFieldDecorator('area', {
            rules: [{
                    validator: CHECK_name(20),
                }],
        })(<Input placeholder="请输入所属区域"/>)}
        </Form.Item>
        <Form.Item label={'所属门店'}>
          {getFieldDecorator('shopName', {
            rules: [{
                    validator: CHECK_name(20),
                }],
        })(<Input placeholder="请输入所属门店"/>)}
        </Form.Item>
        <Form.Item label={'同步时间'} wrapperCol={{ span: 16 }}>
          {getFieldDecorator('time')(<DatePicker.RangePicker className={'width-100'} disabledDate={this.dealDate} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
      </FormLayout>);
    }
}
const FormSearchForm = Form.create({})(FormSearchComponent);
const FormSearch = connect(mapStateToProps)(FormSearchForm);
export default FormSearch;
